module.exports = __webpack_public_path__ + "static/media/bg-launch.85b69aaa.jpg";